import {ColumnDefinition} from "@/components/Roster/Pages/RosterAthletes/Objects/ColumnDefinition";
import {ColumnSorter} from "@/components/Roster/Pages/RosterAthletes/Objects/ColumnSorter";

export class ColumnDefinitions
{
    constructor(definitions = [], columnSorter = new ColumnSorter(definitions)) {
        this.definitions = definitions;
        this.columnSorter = columnSorter;
    }

    static fromRaw(raw) {
        return new ColumnDefinitions(
            raw.map(ColumnDefinition.fromRaw)
        );
    }

    static fromSportFields(sportFields, requiredFields = [], athletes = []) {
        return new ColumnDefinitions(
            sportFields.map((sportField) => ColumnDefinition.fromSportField(sportField, requiredFields, athletes))
        );
    }

    get sortedDefinitions() {
        return this.columnSorter.getSortedColumns();
    }

    toEditableColumns() {
        return this.sortedDefinitions.map(definition => definition.toEditableColumn());
    }

    toPreviewColumns() {
        return this.sortedDefinitions
            .filter((definition) => definition.name !== undefined)
            .map(definition => definition.toPreviewColumn());
    }

    get exportableFields() {
        return this.sortedDefinitions
            .filter((definition) => definition.name !== undefined)
            .map(definition => definition.name);
    }

    merge(other) {
        return new ColumnDefinitions(
            [...this.definitions, ...other.definitions]
        );
    }
}